import { useTranslations } from 'next-intl';

import { InstitutionType, Match } from '@dh/types';
import { LabelMedium } from '@dh/styles';
import { formatDate } from '@dh/utils';

interface Props {
    match: Pick<Match, 'updatedAt' | 'updatedBy'>;
    viewer?: InstitutionType;
}

export const PublishedDisplay = ({ match: { updatedAt, updatedBy }, viewer }: Props) => {
    const t = useTranslations('matching');
    const viewerIsCompany = viewer === InstitutionType.Company;

    return (
        <LabelMedium>
            {viewerIsCompany
                ? t('published_at', { date: formatDate(updatedAt) })
                : t('updated_at_and_by', {
                      date: formatDate(updatedAt),
                      user: !!updatedBy ? `${updatedBy.firstname} ${updatedBy.lastname}` : t('by_unknown')
                  })}
        </LabelMedium>
    );
};
